module.exports = __webpack_public_path__ + "images/2ed83b58503836fd63df84f56664170c.png";